var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowpassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00071 2.25C13.0448 2.25 16.4093 5.15982 17.1147 9C16.4093 12.8401 13.0448 15.75 9.00071 15.75C4.95658 15.75 1.5921 12.8401 0.886719 9C1.5921 5.15982 4.95658 2.25 9.00071 2.25ZM9.00071 14.25C12.1774 14.25 14.8957 12.039 15.5838 9C14.8957 5.96102 12.1774 3.75 9.00071 3.75C5.82394 3.75 3.10565 5.96102 2.41757 9C3.10565 12.039 5.82394 14.25 9.00071 14.25ZM9.00071 12.375C7.13672 12.375 5.62568 10.864 5.62568 9C5.62568 7.13604 7.13672 5.625 9.00071 5.625C10.8646 5.625 12.3757 7.13604 12.3757 9C12.3757 10.864 10.8646 12.375 9.00071 12.375ZM9.00071 10.875C10.0362 10.875 10.8757 10.0355 10.8757 9C10.8757 7.96448 10.0362 7.125 9.00071 7.125C7.96519 7.125 7.12568 7.96448 7.12568 9C7.12568 10.0355 7.96519 10.875 9.00071 10.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowpassword);
export default __webpack_public_path__ + "static/media/showpassword.2219617cd804e3eebc0f31c584e0e3f9.svg";
export { ForwardRef as ReactComponent };